import { Directive, TemplateRef } from '@angular/core';
import { AutocompleteSelectValue } from './autocomplete-select.model';

@Directive({ selector: '[grecoAutocompleteContent]' })
export class AutocompleteSelectContentDirective<T> {
  constructor(public template: TemplateRef<{ $implicit: AutocompleteSelectValue<T>; query: string }>) {}
}
